import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PrivilegeService } from '../services/privilege.service';
import { EPermission } from '../enums/permission.enum';

export const canManageUsersGuard: CanActivateFn = async () => {
  const privilegeService = inject(PrivilegeService);
  const router = inject(Router);

  if (await privilegeService.hasPermission(EPermission.ManageUsers)) {
    return true;
  }

  await router.navigate(['/']);

  return false;
};
